import React from 'react';
import { compose } from 'react-apollo';
import { Helmet } from 'react-helmet';
import ProfileVault from 'containers/ProfileDetailsPage/ProfileVault';
import withPatronAssetsData from 'containers/ProfileDetailsPage/withPatronAssetsData';
import withPatronCmpStatusV2Data from 'containers/ProfileDetailsPage/withPatronCmpStatusV2Data';
import withPatronPlsStatusV2Data from 'containers/ProfileDetailsPage/withPatronPlsStatusV2Data';
import withPatronRewardsData from 'containers/ProfileDetailsPage/withPatronRewardsData';
import withPlsRewardsData from 'containers/ProfileDetailsPage/withPlsRewardsData';
import CloseButton from 'components/CloseButton';
import LoadingIndicator from 'components/LoadingIndicator';
import PageOverlay from 'components/PageOverlay';
import { getUserData } from 'utils/graphQLFunctions';
import { isLocationPls } from 'utils/locations';
import { hasPatronAccount, hasPlsAccount } from 'utils/roles';
import './VaultPage.scss';

const getStatusBasedOnPreferredProperty = preferredLocation =>
  isLocationPls(preferredLocation)
    ? withPatronPlsStatusV2Data
    : withPatronCmpStatusV2Data;

const getRewardsBasedOnPreferredProperty = preferredLocation =>
  isLocationPls(preferredLocation) ? withPlsRewardsData : withPatronRewardsData;

const VaultListWithFullData = preferredLocation =>
  compose(
    getStatusBasedOnPreferredProperty(preferredLocation),
    withPatronAssetsData,
    getRewardsBasedOnPreferredProperty(preferredLocation)
  )(ProfileVault);

const VaultListWithLimitedData = compose(withPatronAssetsData)(ProfileVault);

function VaultPage({ userData }) {
  const user = userData.user;

  if (userData.loading) {
    return <LoadingIndicator expand />;
  }

  if (userData.error || !user) {
    return (
      <div className="alert alert-danger">
        Failed to retrieve player info. If this continues, please contact
        support.
      </div>
    );
  }

  const preferredLocation = user.preferredLocation;
  const VaultListComponent =
    hasPatronAccount(user) || hasPlsAccount(user)
      ? VaultListWithFullData(preferredLocation)
      : VaultListWithLimitedData;

  return (
    <div className="vault-page">
      <PageOverlay>
        <Helmet>
          <title>Vault</title>
        </Helmet>
        <div className="vault-page-title-container">
          <h1 className="vault-page-title">Vault</h1>
        </div>
        <VaultListComponent userData={userData} />
        <CloseButton url="/" />
      </PageOverlay>
    </div>
  );
}

export default getUserData({
  name: 'userData'
})(VaultPage);
